// Module
var code = "<simple-list-layout title-label-code=\"'customers.groups'\" new-entity-label-code=\"'new.customergroup'\" entities=\"customerGroups\" columns=\"columns\"></simple-list-layout> ";
// Exports
export default code;